import React, { useContext, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import _ from "lodash";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getFavoriteDays, deleteFavoriteDay } from "../../../../../api";
import { AuthContext } from "../../../../../auth-context";
import Button from "../../../../../components/button";
import Modal from "../../../../../components/modal";
import { DashboardContext } from "../../../dashboard-context";
import { DayListItem } from "./day-list-item"
import {copyFavoriteDay} from "../../../../../api"

const Container = styled.div`
  margin: 0 auto;
`;

const Title = styled.h2`
  display: flex;
  align-items: center;
  margin: 10px auto 10px auto;
  padding-bottom: 8px;
  color: #181818;
  font-family: "DM Sans", sans-serif;
  font-size: 1.25rem;
  font-weight: 600;

  button {
    margin-left: 16px;
  }
`;

const AddButton = styled(Button)`
  margin: 0;
  margin-right: 16px;
  min-width: 180px;
`;

const RemoveText = styled.h4`
  color: #555;
  font-weight: 600;
  font-size: 1rem;
  text-align: center;
`;

const DaysTable = (props) => {
  const { openSnackbar } = useContext(DashboardContext);
  const { user } = useContext(AuthContext);
  const [showDeleteModal, updateShowDeleteModal] = useState(false);
  const [days, updateDays] = useState(null);
  const [daysStatus, updateDaysStatus] = useState(0);
  const [dayID, updateDayID] = useState(null);
  const [dayName, updateDayName] = useState("");
  const [deleting, updateDeleting] = useState(false);

  useEffect(() => {
    if (daysStatus === 0) {
      updateDaysStatus(1);
      getFavoriteDays(user.id).then((res) => {
        updateDays(res.data.days);
        updateDaysStatus(2);
      });
    }
  }, [daysStatus, user.id]);

  const handleAddTemplateDay = () => {
    props.history.push("/dashboard/template/day-edit/0");
  };

  const handleEdit = (id) => {
    props.history.push("/dashboard/template/day-edit/" + id);
  };

  const handleCopy = (dayID) => {
    copyFavoriteDay(user.id, dayID)
      .then((res) => {
        updateDaysStatus(0);
        openSnackbar("Day template successfully copied", false);
      })
      .catch((err) => {
        if(err?.response?.data?.error) {
          openSnackbar(err.response.data.error, true);
        } else {
          openSnackbar("Error copying day template", true);
        }
      });
  }

  const handleShare = (id) => {
    props.history.push("/dashboard/template/day-share/" + id);
  };

  const handleDeleteIcon = (day) => {
    updateDayID(day.id);
    updateDayName(day.name);
    updateShowDeleteModal(true);
  };

  const handleDelete = () => {
    updateDeleting(true);

    deleteFavoriteDay(user.id, dayID)
      .then((res) => {
        let newDays = days.slice(0);
        _.remove(newDays, (day) => {
          return day.id === dayID;
        });

        setTimeout(() => {
          updateDeleting(false);
          updateDays(newDays);
          updateShowDeleteModal(false);
          openSnackbar("Day template successfully deleted", false);
        }, 700);
      })
      .catch((err) => {
        updateDeleting(false);
        updateShowDeleteModal(false);
        openSnackbar("Error deleting day template", true);
      });
  };

  const renderView = () => {
    if (daysStatus !== 2) {
      return <CircularProgress size={32} />;
    } else if (days.length === 0) {
      return (
        <p>You have no day templates yet. Click "Add Day Template" below.</p>
      );
    } else {
      return days.map((entry) => (
        <DayListItem 
          day={entry}    
          edit={handleEdit}
          copy={() => handleCopy(entry.id)}
          share={handleShare}
          remove={handleDeleteIcon}
        />
      ));
    }
  };

  return (
    <Container>
      <Title>Day Templates<AddButton label="Add Day Template" onClick={handleAddTemplateDay} /></Title>
      {renderView()}
      <Modal
        title={`Delete Day Template`}
        message={`Are you sure you want to delete this day template?`}
        submitLabel="Delete"
        open={showDeleteModal}
        onClose={() => updateShowDeleteModal(false)}
        handleSubmit={handleDelete}
        warning
        disabled={deleting}
        isLoading={deleting}
      >
        <RemoveText>{dayName}</RemoveText>
      </Modal>
    </Container>
  );
};

export default withRouter(DaysTable);
